<template>
    <div class="specialist-dashboard-analytics">
        <div class="header-row">
            <router-link to="/organizationDashboard/insights" class="insight-button">
            ← Back to Insights
            </router-link>
            <div class="title">Detailed Progress Analytics</div>
            <div class="right-tabs">
            <div class="tabs">
                <router-link
                :to="{ path: '/SpecialistDashboard/analytics', query: { tab: 'screening' } }"
                class="tab-button"
                :class="{ active: activeTab === 'screening' }"
                >
                Screening / Mini-Test
                </router-link>
                <router-link
                :to="{ path: '/SpecialistDashboard/analytics', query: { tab: 'assessments' } }"
                class="tab-button"
                :class="{ active: activeTab === 'assessments' }"
                >
                Assessments
                </router-link>
                <router-link
                :to="{ path: '/SpecialistDashboard/analytics', query: { tab: 'interventions' } }"
                class="tab-button"
                :class="{ active: activeTab === 'interventions' }"
                >
                Interventions
                </router-link>
                </div>
            </div>
            </div>
        <div class="row-1-graphs">
            <div class="activity-graph">
                <div v-if="activeTab === 'assessments'">
                    <div class="header-actions">
                        <h3>Assessments</h3>
                        <div class="pill-toggle">
                        <button
                            :class="{ active: yearType === 'calendar' }"
                            @click="updateYearType('calendar')"
                        >
                            Calendar Year
                        </button>
                        <button
                            :class="{ active: yearType === 'academic' }"
                            @click="updateYearType('academic')"
                        >
                            School Year
                        </button>
                        </div>
                        <button class="icon-button">⚙</button>
                    </div>
                    <div class="subtext">Planned vs. Completed</div>
                    <div class="card-body">
                        <BarChartGroupedECharts
                            :months="analytics.activity_comparison.months"
                            :lastYear="analytics.activity_comparison.last_year"
                            :present="analytics.activity_comparison.this_year"
                        />
                    <div class="chart-legend">
                        <div class="legend-item">
                            <span class="legend-color last-year"></span>
                            Last Year
                        </div>
                        <div class="legend-item">
                            <span class="legend-color present"></span>
                            Present
                        </div>
                        <div class="legend-item">
                            <span class="legend-color na"></span>
                            N/A
                        </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="activeTab === 'interventions'">
                    <div class="header-actions">
                        <h3>Interventions</h3>
                        <div class="pill-toggle">
                        <button
                            :class="{ active: yearType === 'calendar' }"
                            @click="updateYearType('calendar')"
                        >
                            Calendar Year
                        </button>
                        <button
                            :class="{ active: yearType === 'academic' }"
                            @click="updateYearType('academic')"
                        >
                            School Year
                        </button>
                        </div>
                        <button class="icon-button">⚙</button>
                    </div>
                    <div class="subtext">Planned vs. Completed</div>
                    <div class="card-body">
                        <BarChartGroupedECharts
                            :months="analytics.activity_comparison.months"
                            :lastYear="analytics.activity_comparison.last_year"
                            :present="analytics.activity_comparison.this_year"
                        />
                    <div class="chart-legend">
                        <div class="legend-item">
                            <span class="legend-color last-year"></span>
                            Last Year
                        </div>
                        <div class="legend-item">
                            <span class="legend-color present"></span>
                            Present
                        </div>
                        <div class="legend-item">
                            <span class="legend-color na"></span>
                            N/A
                        </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="activeTab === 'screening'">
                    <div class="header-actions">
                        <h3>Screening/Mini-Tests</h3>
                        <div class="pill-toggle">
                            <button
                                :class="{ active: yearType === 'calendar' }"
                                @click="updateYearType('calendar')"
                            >
                                Calendar Year
                            </button>
                            <button
                                :class="{ active: yearType === 'academic' }"
                                @click="updateYearType('academic')"
                            >
                                School Year
                            </button>
                        </div>
                        <button class="icon-button">⚙</button>
                    </div>
                    <div class="subtext">Planned vs. Completed</div>
                    <div class="card-body">
                        <BarChartGroupedECharts
                            :months="analytics.activity_comparison.months"
                            :lastYear="analytics.activity_comparison.last_year"
                            :present="analytics.activity_comparison.this_year"
                        />
                    <div class="chart-legend">
                        <div class="legend-item">
                            <span class="legend-color last-year"></span>
                            Last Year
                        </div>
                        <div class="legend-item">
                            <span class="legend-color present"></span>
                            Present
                        </div>
                        <div class="legend-item">
                            <span class="legend-color na"></span>
                            N/A
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="score-trend-graph">
                <div class="header-actions">
                    <div v-if="activeTab === 'screening'">
                        <h3>Score Trend</h3>
                    </div>
                    <div v-else-if="activeTab === 'assessments'">
                        <h3>Score Trend</h3>
                    </div>
                    <div v-else-if="activeTab === 'interventions'">
                        <h3>Mini-Test Score</h3>
                    </div>
                    <div class="left-group">
                        <div class="sort-by">
                            <label>Sort By:</label>
                            <select v-model="area" @change="fetchAnalyticsReport()">
                                <option value="Cognitive">Cognitive</option>
                                <option value="Motor">Motor</option>
                                <option value="Speech and Language">Speech and Language</option>
                                <option value="Reading and Writing">Reading and Writing</option>
                                <option value="Mental Health">Mental Health</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        <button class="icon-button">⚙</button>
                    </div>
                </div>
                <div v-if="activeTab === 'assessments'">
                        <LineChartScoreECharts
                            :months="analytics.score_trend.months"
                            :scores="analytics.score_trend.this_year"
                        />
                </div>
                <div v-else-if="activeTab === 'interventions'">
                        <LineChartScoreECharts
                            :months="analytics.score_trend.months"
                            :scores="analytics.score_trend.this_year"
                        />
                </div>
                <div v-else-if="activeTab === 'screening'">
                        <LineChartScoreECharts
                            :months="analytics.score_trend.months"
                            :scores="analytics.score_trend.this_year"
                        />
                </div>
            </div>
        </div>
        <div class="row-2-graphs">
            <div class="progress-graph">
                <div class="header-actions">
                    <h3>Progress Graph</h3>
                    <button class="icon-button">⚙</button>
                </div>
                <div class="graph-container">
                <div v-if="activeTab === 'assessments'">
                        <LineChartGroupedECharts
                            :months="analytics.progress_comparison.months"
                            :lastYear="analytics.progress_comparison.last_year"
                            :present="analytics.progress_comparison.this_year"
                        />
                </div>
                <div v-else-if="activeTab === 'interventions'">
                        <LineChartGroupedECharts
                            :months="analytics.progress_comparison.months"
                            :lastYear="analytics.progress_comparison.last_year"
                            :present="analytics.progress_comparison.this_year"
                        />
                </div>
                <div v-else-if="activeTab === 'screening'">
                        <LineChartGroupedECharts
                            :months="analytics.progress_comparison.months"
                            :lastYear="analytics.progress_comparison.last_year"
                            :present="analytics.progress_comparison.this_year"
                        />
                </div>
                </div>
                <div class="chart-legend">
                        <div class="legend-item">
                            <span class="legend-color last-year-2"></span>
                            Last Year
                        </div>
                        <div class="legend-item">
                            <span class="legend-color present-2"></span>
                            Present
                        </div>
                </div>
            </div>
            <div class="radar-graph">
                <div class="header-actions">
                    <h3>NLC-1</h3>
                    <button class="icon-button">⚙</button>
                </div>
                <div class="radar-test-type">{{area}}</div>
                <div v-if="activeTab === 'assessments'">
                        <RadarChartNLCECharts
                            :dataInput="analytics.progress.percentage"
                        />
                </div>
                <div v-else-if="activeTab === 'interventions'">
                        <RadarChartNLCECharts
                            :dataInput="analytics.progress.percentage"
                        />
                </div>
                <div v-else-if="activeTab === 'screening'">
                        <RadarChartNLCECharts
                            :dataInput="analytics.progress.percentage"
                        />
                </div>
            </div>
        </div> 
    </div>
</template>

<script>
import BarChartGroupedECharts from '@/components/subComponents/BarChartGroupedECharts.vue'
import LineChartScoreECharts from './subComponents/LineChartScoreECharts.vue';
import LineChartGroupedECharts from './subComponents/LineChartGroupedECharts.vue';
import RadarChartNLCECharts from './subComponents/RadarChartNLCECharts.vue';
import axios from 'axios';

export default {
    name: 'OrganizationDashboardAnalytics',
    components: {
        BarChartGroupedECharts,
        LineChartScoreECharts,
        LineChartGroupedECharts,
        RadarChartNLCECharts
    },
    data() {
        return {
            activeTab: 'interventions',
            yearType:'calendar',
            area: 'Cognitive',
            analytics: null,
        };
    },
    methods: {
        syncTab() {
          this.activeTab = this.$route.query.tab || 'screening';
        },
        async fetchAnalyticsReport() {
          try {
        const baseUrl = process.env.VUE_APP_REVERSE_PROXY_ENDPOINT || "http://localhost:8081";

        const authResp = await fetch(`${baseUrl}/api/auth/get-access-cookie-data`, {
          credentials: "include",
        });
        if (!authResp.ok) throw new Error("Failed to fetch auth cookie data");
        const authData = await authResp.json();
        const ID = authData.id;

        let classification = null

        if (this.activeTab === 'screening') {
        classification = 'Screening/Mini-Test'
        } else if (this.activeTab === 'assessments') {
        classification = 'Assessment/Test'
        } else if (this.activeTab === 'interventions') {
        classification = 'Intervention/Training/Lesson'
        }

        const params = {
        classification,
        yearType: this.yearType,
        area: this.area
        }


        const response = await axios.get(
          `${baseUrl}/api/specialist/user/${ID}/analytics-report`,
          { params }
        )
        
        this.analytics = response.data;
        console.log("Fetched analytics report:", this.analytics);

      } catch (error) {
        console.error("Error fetching analytics report:", error);
      }
    },
    updateYearType(newType){
        this.yearType = newType;
    }
    },
    watch: {
        activeTab() {
            this.fetchAnalyticsReport();
        },

        yearType() {
            this.fetchAnalyticsReport();
        },

        area() {
            this.fetchAnalyticsReport();
        },

        '$route.query.tab': {
             immediate: true,
             handler(newTab) {
             this.activeTab = newTab || 'screening';
             this.fetchAnalyticsReport();
             }
        }
        },
    mounted() {
        this.syncTab();
        this.fetchAnalyticsReport();
        this.updateYearType();
    },
    }
</script>

<style scoped>
.specialist-dashboard-analytics {
    padding: 40px;
    margin-top: 50px;
    background-color: #f9f9f9;
}
.header-row {
    display: flex;
    align-items: center;
    gap: 20px;
}
.title{
    font-size: 24px;
    font-weight: 600;
}
.insight-button {
    text-decoration: none;
    color: black;
    font-weight: 500;
    font-size: 16px;
    &:hover {
        text-decoration: underline;
        color: #333
    }
}
.right-tabs {
    display: flex;
    margin-left: auto;
    justify-content: right;
    align-items: center;
    text-decoration: none;

}
.tabs {
  display: flex;
  justify-content: right;
  gap: 10px;
  margin-top: 28px;
  border: 0.5px solid #ddd;
  border-radius: 8px;
  padding: 4px;
  text-decoration: none;
  color: black;
}
.tab-button {
  padding: 9px 18px;
  cursor: pointer;
  font-size: 14px;
  transition: 0.2s;
  border-radius: 8px;
  margin-top: 4px;
  margin-bottom: 8px;
  text-decoration: none;
  color: inherit;
}
.tab-button:hover {
  background: #f2f2f2;
}
.tab-button.active {
  color: #9D5f0E;
  background-color: #FFF5E3;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: underline;
}
.row-1-graphs, .row-2-graphs {
    display: flex;
    gap: 20px;
    margin-top: 30px;
}
.activity-graph, .score-trend-graph, .progress-graph, .radar-graph {
    background-color: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    flex: 1;
}
.graph-container{
    height: 400px;
}
.header-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

/* Toggle pills */
.pill-toggle {
  display: flex;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 4px;

  button {
    border: none;
    background: transparent;
    padding: 6px 12px;
    font-size: 13px;
    border-radius: 999px;
    cursor: pointer;
    color: #6b7280;

    &.active {
      background: #f59e0b;
      color: #fff;
      font-weight: 600;
    }
  }
}
.subtext {
        font-size: 14px;
        color: #6b7280;
}

.left-group {
  display: flex;
  align-items: center;
  gap: 12px;
}
.sort-by {
  display: flex;
  align-items: center;
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 4px 12px;
  gap: 6px;

  label {
    font-size: 14px;
    color: gray;
    margin: 0;
  }
  select {
    appearance: none; 
    border: none;
    background: #f9fafb;
    font-size: 14px;
    padding: 6px 24px 6px 0;
    cursor: pointer;
    outline: none;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='none' stroke='%23666' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 8l4 4 4-4' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 4px center;
    background-size: 16px 16px;
  }
}
/* Settings icon */
.icon-button {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #C56C00;
}

/* Body */
.card-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Chart container */
.chart-area {
  height: 100%;
  width: 100%;
  border-radius: 8px;
}

/* Legend */
.chart-legend {
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  font-size: 12px;
  color: #6b7280;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.legend-color {
  width: 14px;
  height: 6px;
  border-radius: 3px;

  &.last-year {
    background: #fde68a;
  }

  &.present {
    background: #f59e0b;
  }

  &.na {
    background: #d1d5db;
  }
  &.last-year-2 {
    background: #ff92ae;
  }
  &.present-2 {
    background: #65e9f0;
  }
}   
.radar-test-type {
    font-size: 14px;
    color: #C56C00;
    margin-bottom: 10px;
}
</style>